import React, { useContext } from "react";
import Footer from "./Footer";
import config from "../config/index.json";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/UserContext";
import Spinner from "./Spinner";
import SimpleHeader from "./SimpleHeader";

import { getDatabase, ref, get } from "firebase/database";

function Login() {
  const { signIn, loading, setPermission } = useContext(AuthContext);
  const navigate = useNavigate();
  const { images } = config;
  const { logo } = images;

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const form = e.target;
    const email = form.email.value;
    const password = form.password.value;
    signIn(email, password)
      .then((result: any) => {
        form.reset();
        const user = result.user
        const db = getDatabase();
        get(ref(db, "users/" + user.uid)).then((userInfo)=>{
          console.log(userInfo.val())
          if (userInfo.val()?.permission=='admin')
          {
            setPermission('admin');
          }
          else
          {
            setPermission('user');
          }
          navigate('/reserved-area');
        })
        .catch((error:any)=>{
          console.log('error',error);
        })
      })
      .catch((error: any) => {
        console.error(error);
        form.reset();
      });
  };
  return (
    <>
      <section
        id="hero"
        className="bg-hero brightness-100 bg-no-repeat w-full bg-center bg-cover pt-80 pb-6 h-[40vh]"
      >
        {/* <div
          id="header"
          className="absolute w-full top-0 z-20 pt-4 md:pt-16 pb-4 px-4 md:px-16"
        >
          <div className="flex justify-center md:justify-between flex-col-reverse	md:flex-row">
            <div className="flex items-left md:items-center">
              <img
                src={logo}
                className="mt-16 md:my-4 w-40 block mr-auto ml-0 md:mx-auto"
                alt="logo"
              />
            </div>
          </div>
        </div> */}
      </section>
      <SimpleHeader/>
      <section>
        <div className="pb-[200px]">
          <div className="grid grid-cols-1 md:grid-cols-5">
            <div className="col-span-2 pt-[100px] pl-[60px] md:pr-[20px] lg:pr-[60px]">
              <hr className="color-[#00a695] border border-[#00a695] w-4/5" />
              <div className="mt-[20px]">
                <strong>Hai bisogno di aiuto?</strong>
              </div>
              <a className="text-[#00a695]" href="">
                info@italyhlg.it
              </a>
              <p className="mt-[40px]">
                L 'iscrizione a Italy HLG permette di usufruire di:
              </p>
              <ul className="mt-[20px] pl-[40px] list-disc gap-[10px]">
                <li>
                  Ampie possibilità di Network con
                  <strong>
                    altri professionisti del licensing e del business
                    development
                  </strong>
                  di aziende e organizzazioni nel settore Healthcare.
                </li>
                <li>
                  <strong>Accesso alla sezione riservata</strong>del sito.
                </li>
                <li>
                  Offre{" "}
                  <strong>partecipazione ad eventi di alta formazione</strong>
                  (BD Academy), godendo di condizioni economiche di favore
                  riservate agli associati.
                </li>
                <li>
                  Partecipazione ad altre
                  <strong>iniziative culturali e ricreative</strong>organizzate
                  dall'associazione con la finalità di
                  <strong>sviluppare il network.</strong>
                </li>
                <li>
                  Partecipazione ad{" "}
                  <strong>
                    eventi organizzati da IPLS International Partnering in
                    Lifescience Society e dalle altre associate EU.
                  </strong>
                </li>
                <li>
                  <strong>
                    Abbonamento al Business Development & Licensing Journal.
                  </strong>
                </li>
              </ul>
              {/* Button */}
              
             
              <div className="w-full mt-6 flex justify-center items-center">
                <a
                  className="w-[80%] px-20 py-6 bg-[#12357a] text-white text-center text-xs"
                  href="/register"
                >
                  ISCRIZIONE
                </a>
              </div>
            </div>
            <div className="col-span-3 z-10 mt-[-120px]">
              <div className=" z-50 bg-white p-24">
                <div className="text-5xl text-[#0c2957] font-[700]">
                  <h1 className="mb-6">Accesso</h1>
                  <h1>Area Riservata</h1>
                </div>
                <p className="mt-6 font-[600]">
                In area riservata sono disponibili per gli iscritti Italy HLG le presentazioni dei relatori ospiti dei nostri Meeting, link a webinar e immagini e quant'altro sia stato raccolto attraverso le nostre attività, oltre alla collezione delle varie uscite del BD and Licensing Journal.

                </p>
                {loading && <Spinner />}
                <form className="mt-6 w-[80%]" onSubmit={handleSubmit}>
                  <input
                    id="email"
                    name="email"
                    className="block w-full p-5 my-4 border border-1"
                    type="email"
                    placeholder="E-mail"
                    required
                  />
                  <input
                    id="password"
                    name="password"
                    className="block w-full p-5 my-4 border border-1"
                    type="password"
                    placeholder="Password"
                    required
                  />
                  <button
                    className="block w-full p-6 my-4 uppercase text-white text-xs bg-[#00a695]"
                    type="submit"
                  >
                    LOGIN
                  </button>
                  <div className="w-full text-left px-6 flex flex-col">
                    {/* <div>
                      Se non hai un account, registrati {" "}<Link to="/register" className="underline">qui.</Link>
                    </div> */}
                    <div>
                      Hai dimenticato la password?{" "}
                      <Link to="/recover" className="underline">
                         Recuperala
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer></Footer>
    </>
  );
}

export default Login;
